import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const phoneVerificationApiSlice = createApi({
  reducerPath: "VerifyPhoneNumberApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND,
  }),
  endpoints: (builder) => ({
    sendOtpCode: builder.mutation({
      query: (params) => ({
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": process.env.REACT_APP_X_API_KEY
        },
        url: "/api/send_otp",
        method: "POST",
        body: params,
      }),
      transformResponse: (response) => {
        if (response.message !== "OTP sent successfully") {
          throw new Error("Failed to send OTP code");
        }
        return response;
      },
    }),
    verifyOtpCode: builder.mutation({
      query: (params) => ({
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": process.env.REACT_APP_X_API_KEY
        },
        url: "/api/verify_otp",
        method: "POST",
        body: params,
      }),
      transformResponse: (response) => {
        if (response.status !== "approved") {
          throw new Error("Failed to verify OTP code");
        }
        return response;
      },
    }),
  }),
});

export const { useSendOtpCodeMutation, useVerifyOtpCodeMutation } = phoneVerificationApiSlice;